import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AgePipe } from './age.pipe';
import { ExcerptPipe } from './excerpt.pipe';
import { GetValueByKeyPipe } from './get-value-by-key.pipe';
import { RelativeTimePipe } from './relative-time.pipe';
import { SafePipe } from './safe.pipe';
import { TimeAgoPipe } from './time-ago.pipe';
import { TrackByPropertyPipe } from './trackby.pipe';
import { AbleraTranslatePipe } from './translate-value-parser.pipe';

const pipes = [RelativeTimePipe, ExcerptPipe, GetValueByKeyPipe, TrackByPropertyPipe, SafePipe, TimeAgoPipe, AbleraTranslatePipe, AgePipe];

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: pipes,
  exports: pipes
})
export class SharedPipesModule {}
